export default __webpack_public_path__ + "static/Agile-MediumItalic-a3ae3593ea666d8775180547287b4e0a.ttf";